// extracted by mini-css-extract-plugin
export default {"currencyFieldWrapper":"TradingAccountDepositPSPFields_currencyFieldWrapper__8lauo"};